export default "__VITE_ASSET__919459a1__"